export default {
      id: "icon-xs-cross-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-xs-cross",
      toString: function () {
        return this.url;
      }
    }